import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadClienteArquivoUseCase } from "../../../presentation/useCases/read/download_cliente_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DownloadClienteArquivoUseCase
 */

export class DownloadClienteArquivoUseCase implements IDownloadClienteArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idClienteArquivo: number, nomeArquivo: string): Promise<void> {
    const response = await this.repository.downloadClienteArquivoS3(idClienteArquivo);
    if (response === null) throw new Error('Falha ao buscar dados da image!');
    await downloadFromBlobUrl(response, nomeArquivo);

  }
}
